import { ImgIcon } from "@panwds/react-ui";
import panw_aws_logo from '../../images/panw_aws_logo.png';
import SignUpV2 from "./SignUpV2";
import styles from './styles/Register.module.scss';
import bgImage from '../../images/login-background.png';
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSubscriptionParams } from './hooks/useSubscriptionParams';
import { HelpContent } from './components/HelpContent';
import { ListingType } from '../../interfaces/interfaces';


const Register = () => {
    const { listing: urlListing, accountStatus } = useSubscriptionParams();
    const location = useLocation<{ queryString?: { listing?: string } }>();
    // After SSO redirect, the listing param is lost from the URL but preserved in location.state.
    // Prefer state-sourced listing over URL-sourced so AIRFM help content is shown correctly.
    const stateListing = location.state?.queryString?.listing;
    const listing: ListingType = (stateListing === 'AIRFM' || stateListing === 'CNGFW')
        ? stateListing as ListingType
        : urlListing;
    const [hasCode, setHasCode] = useState("");
    const panelRef = useRef<HTMLDivElement>(null);
    const maxHeightRef = useRef<number>(0);

    // Lock the content panel to its maximum observed height to prevent shrinking
    useEffect(() => {
        if (panelRef.current) {
            const currentHeight = panelRef.current.offsetHeight;
            if (currentHeight > maxHeightRef.current) {
                maxHeightRef.current = currentHeight;
            }
            panelRef.current.style.minHeight = `${maxHeightRef.current}px`;
        }
    }, [hasCode]);

    return (
        <div style={{ backgroundImage: `url(${bgImage})` }} className={`${styles.backgroundCover} tw-relative tw-h-screen tw-w-full`}>
            {/* Icons in top left corner */}
            <div className={`${styles.iconsContainer}`}>
                <ImgIcon alt="Palo Design System" src={panw_aws_logo} size="xxl" />
            </div>

            {/* Content panel centered on page */}
            <div ref={panelRef} className={`${styles.contentPanel}`}>
                <div className={`${styles.contentChild} ${styles.inputContentV2}`}>
                    <SignUpV2 setHasCode={setHasCode}/>
                </div>
                <div className={`${styles.contentChild} ${styles.helpContentV2}`}>
                    <HelpContent hasCode={hasCode} listing={listing} accountStatus={accountStatus} />
                </div>
            </div>
        </div>
    );
};

export default Register;
